
































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import { studentModule } from '@/store/modules/entities/student.module';
import { Student } from '@/models/student/student';
import { FindingsProposalDescription, StudentFindingsProposals } from '@/models/student/student-findings-proposals';
import GStudentRecordFindingsProposalsTable from '@/views/GStudentRecord/GStudentRecordFindingsProposalsTable.vue';

@Component({
  name: 'GStudentRecordFindingsProposals',
  components: { GStudentRecordFindingsProposalsTable },
  computed: {},
  methods: {},
})
export default class GStudentRecordFindingsProposals extends mixins(GPageBase) {
  findingsProposalsListColumn: object[] = [];

  @Prop() studentID: number;

  async mounted() {
    await studentModule.fetchStudentFindingsProposals(this.studentID);
  }

  get studentFindingsProposals(): StudentFindingsProposals {
    return studentModule.studentFindingsProposals;
  }

  isDisplayFindingsProposalsTable(competencies: FindingsProposalDescription[]): boolean {
    return competencies.filter(competency => !!competency.competencyScore).length > 0;
  }
}
